import { Divider, Grid } from '@material-ui/core';
import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent';
import FinanciarFunctions from './FinanciarFunctions';
import InterpretareComponent1 from './InterpretareComponent1';
import InterpretareComponent2 from './InterpretareComponent2';
import InterpretareLabelComponent from './InterpretareLabelComponent';
import ChartCashflow from './ChartCashflow';
import Utils from '../../providers/Utils';

export default class AnalizaCashFlow extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            arrow1: false,
            arrow2: false,



        }
    }

    componentDidMount() {


    }

    u = new Utils()

    displayArrow = (arr) => {

        this.setState({ [arr]: true })
    }



    diffCosturi = (an1, an2) => {

        let cost1 = this.f.cashFlowCosturi(an1)
        let cost2 = this.f.cashFlowCosturi(an2)


        if (cost1 > cost2) {
            return false
        } else {
            return true
        }

    }



    diffVenituri = (an1, an2) => {

        let venit1 = this.f.getTotalVenituriBilant(an1)
        let venit2 = this.f.getTotalVenituriBilant(an2)


        if (venit1 > venit2) {
            return false
        } else {
            return true
        }

    }

    diffCheltuieli = (an1, an2) => {

        let cheltuiala1 = this.f.cashFlowCheltuieli(an1)
        let cheltuiala2 = this.f.cashFlowCheltuieli(an2)


        if (cheltuiala1 > cheltuiala2) {
            return true
        } else {
            return false
        }

    }




    f = new FinanciarFunctions()




    render() {
        return (
            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.analizaCashFlow} </h5>


                    <Divider className='pm-divider' />
                </Grid>

                <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>

                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.cheltuieliSiCosturi} </h5>



                        </Grid>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <Grid container>
                                <Grid style={{ textAlign: 'left', lineHeight: 1 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <span style={{ fontSize: 12, color: 'rgb(121	121	121	)' }}>{this.dictionary.financiar.mesajAnalizaCashFlow}</span>
                                </Grid>

                                <Grid style={{ textAlign: 'left', marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container>



                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Grid style={{ textAlign: 'center' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.costuri}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber( this.f.cashFlowCosturi(this.props.bilanturiDesc[0]))} Lei</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <i
                                                        style={{
                                                            verticalAlign: 'middle',
                                                            color: !this.diffCosturi(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                        }}
                                                        className='material-icons'>{this.diffCosturi(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'trending_down' : 'trending_up'} </i>
                                                </Grid>



                                            </Grid>
                                        </Grid>

                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Grid style={{ textAlign: 'center' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.cheltuieli}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.f.cashFlowCheltuieli(this.props.bilanturiDesc[0])) } Lei</span>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <i
                                                        style={{
                                                            verticalAlign: 'middle',
                                                            color: !this.diffCheltuieli(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                        }}
                                                        className='material-icons'>{this.diffCheltuieli(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'trending_up' : 'trending_down'} </i>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                                            <Grid style={{ textAlign: 'center' }} container>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 600, color: 'black' }}>{this.dictionary.financiar.venituri}</span>
                                                </Grid>
                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <span style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400, color: 'black' }}>{this.u.formatNumber(this.f.getTotalVenituriBilant(this.props.bilanturiDesc[0])) } Lei</span>
                                                </Grid>

                                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                    <i
                                                        style={{
                                                            verticalAlign: 'middle',
                                                            color: !this.diffVenituri(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'rgb(24 165 58)' : 'rgb(211 58	64)'
                                                        }}
                                                        className='material-icons'>{this.diffVenituri(this.props.bilanturiDesc[0], this.props.bilanturiDesc[1]) ? 'trending_down' : 'trending_up'} </i>
                                                </Grid>
                                            </Grid>
                                        </Grid>


                                    </Grid>


                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            <ChartCashflow

                                bilanturi={this.props.bilanturiAsc}
                            />
                        </Grid>


                    </Grid>
                    <Divider style={{ marginTop: 20 }} className='pm-divider' />
                </Grid>

                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} >{this.dictionary.financiar.fluxulDeNumerar} </h5>



                        </Grid>


                    </Grid>

                    <Grid container>
                        <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                            {this.props.bilanturiDesc &&
                                <InterpretareComponent2
                                labels={[this.dictionary.financiar.negativ , this.dictionary.financiar.pozitiv]}
                                    arrow1={this.state.arrow1}
                                    arrow2={this.state.arrow2}
                                    displayArrow={this.displayArrow}
                                    interpretare2={true}
                                    val1={this.f.fluxulDeNumerar(this.props.bilanturiDesc[0])}
                                    val2={null}
                                    cF1={0}
                                    cF2={0}
                                />
                            }



                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={6} sm={6} md={6} lg={6} xl={6}>



                            <span>{this.dictionary.financiar.situatie}:  <span style={{ color: this.f.fluxulDeNumerar(this.props.bilanturiDesc[0]) > 0 ? 'rgb(24 165 58)' : 'rgb(211 58	64)' }}>{this.f.fluxulDeNumerar(this.props.bilanturiDesc[0]) > 0 ? this.dictionary.financiar.fluxPozitiv : this.dictionary.financiar.fluxNegativ} </span></span>



                        </Grid>


                    </Grid>

                </Grid>


                <Grid style={{textAlign: 'left'}}   item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <span style={{fontSize: 12}}> {this.dictionary.financiar.analizaCashFlowText}</span>
                </Grid>
            </Grid>
        );
    }
}